export const DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';

export const displayMessage = message => ({
    type: DISPLAY_MESSAGE,
    message
});

export const removeMessage = (id, messageType, alignment) => ({
    type: REMOVE_MESSAGE,
    id,
    messageType,
    alignment
});